import { render, staticRenderFns } from "./Sets.vue?vue&type=template&id=f597878c&scoped=true"
import script from "./Sets.vue?vue&type=script&lang=ts&setup=true"
export * from "./Sets.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Sets.vue?vue&type=style&index=0&id=f597878c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f597878c",
  null
  
)

export default component.exports